<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'LocationsPage',

};
</script>

<style>

</style>
